<script lang="ts">
  import { push } from "svelte-spa-router";
  import Wizard from "$lib/components/onboarding/Wizard.svelte";

  import TeamForm from "$lib/components/identity/TeamForm.svelte";
  import MembersForm from "$lib/components/identity/MembersForm.svelte";
  import AppForm from "$lib/components/apps/AppForm.svelte";
  import DataSourcesForm from "$lib/components/integrations/DataSourcesForm.svelte";
  import IntegrateFrontendStep from "$lib/components/apps/IntegrateFrontendStep.svelte";
  import IntegrateBackendStep from "$lib/components/apps/IntegrateBackendStep.svelte";
  import IntegrateInstallStep from "$lib/components/apps/IntegrateInstallStep.svelte";

  import LogoGraphic from "$assets/icons/logo-graphic.svelte";
  import FullPageShell from "$lib/components/layout/FullPageShell.svelte";

  let step = 0;
  $: step;

  const steps = [
    {
      title: "Create your team",
      subtitle: "Assign your team an alias and team ID",
      component: TeamForm,
    },
    {
      title: "Add members",
      subtitle: "Invite your team members",
      component: MembersForm,
      props: {
        allowSkip: true,
      },
    },
    {
      title: "Create your first app",
      subtitle: "Follow some step-by-step instructions to get you integrated with multiple apps",
      component: AppForm,
      props: {
        isEdit: false,
        allowSkipToEnd: true,
      },
    },
    {
      title: "Integrate data sources",
      subtitle: "Choose a product to integrate with by following step-by-step instructions.",
      component: DataSourcesForm,
      props: {
        allowSkipToEnd: true,
      },
    },
    {
      title: "Integrate data sources",
      subtitle: "Choose a product to integrate with by following step-by-step instructions.",
      component: IntegrateFrontendStep,
      props: {
        allowSkipToEnd: true,
      },
    },
    {
      title: "Integrate data sources",
      subtitle: "Choose a product to integrate with by following step-by-step instructions.",
      component: IntegrateInstallStep,
      props: {
        allowSkipToEnd: true,
      },
    },
    {
      title: "Integrate data sources",
      subtitle: "Choose a product to integrate with by following step-by-step instructions.",
      component: IntegrateBackendStep,
    },
  ];

  const onFinish = () => {
    // TODO: get teamID out of Wizard
    push(`/team-id`);
  };
</script>

<FullPageShell
  mainClass="overflow-auto max-h-[100svh] !pb-0 onboarding"
  class="flex flex-col items-center gap-8 md:gap-12"
  hasBackground={true}
>
  <div class="mt-4 md:mt-12 flex flex-col items-center gap-4 md:gap-6">
    <div class="[&>svg]:h-7 md:[&>svg]:h-12">
      <LogoGraphic />
    </div>
    <div class="flex flex-col items-center gap-1 md:gap-2 text-center">
      <h1>{steps[step].title}</h1>
      <p>{steps[step].subtitle}</p>
    </div>
  </div>

  <div class="flex-1 flex flex-col w-full max-w-2xl">
    <Wizard {steps} {onFinish} bind:wizardStep={step} />
  </div>
</FullPageShell>
